import { render, staticRenderFns } from "./favorites.vue?vue&type=template&id=c44e6acc&scoped=true&"
import script from "./favorites.vue?vue&type=script&lang=js&"
export * from "./favorites.vue?vue&type=script&lang=js&"
import style0 from "./favorites.vue?vue&type=style&index=0&id=c44e6acc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44e6acc",
  null
  
)

export default component.exports